// import store from '@/state/store'
import isSacrificialMiddleware from '../middleware/isSacrificialMiddleware'

export default [
 
  {
    path: '/',
    name: 'default',
    component: () => import('./views/apartment-complex/employee')
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },

  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/housing-loans/martyrs/:code(\\d{10})',
    name: 'martyr',
    component: () => import('./views/apartment-complex/martyr'),
    beforeEnter:isSacrificialMiddleware
  },
  {
    path: '/housing-loans/woundeds',
    name: 'injured',
    component: () => import('./views/apartment-complex/injured')
  },
  {
    path: '/housing-loans/employees',
    name: 'employee',
    component: () => import('./views/apartment-complex/employee')
  },
]
